
  
const initState = {
    lasherCatalogue: [],
    page: 1,
    limit: 10,
    count: 0
  };
  
  const LasherCatalogueReducer = (state = initState, action) => {
    switch (action.type) {
      case 'SET_LASHERCATALOGUE':
        return {
          ...state,
          lasherCatalogue: action.payload.data,
          page: action.payload.page,
          limit: action.payload.limit,
          count: action.payload.count
        };
      case 'RESET_LASHERCATALOGUE':
        return {
          ...state,
          ...initState
        };
      default:
        return { ...state };
    }
  };
  
  export default LasherCatalogueReducer;
  